// ** Tailwind Styles
import tw from "tailwind-styled-components"

export const GlobalContainer = tw.div`md:px-4 desktop:px-[50px] xl:px-[100px] container mx-auto`
export const SectionWithBorderB = tw.div`pt-5 pb-5 border-b border-netural-30`
